/**
 * Configuração global do Axios com retry automático
 * Importar este ficheiro no index.js para aplicar a todas as chamadas
 */

import axios from 'axios';

const MAX_RETRIES = 5;
const RETRY_DELAY = 500;
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Configurar interceptor de resposta para TODAS as chamadas axios
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    
    // Evitar loop infinito - verificar se já está em retry
    if (!config || config.__isRetry) {
      return Promise.reject(error);
    }
    
    // Inicializar contador de retry
    config.__retryCount = config.__retryCount || 0;
    
    const status = error.response?.status;
    
    // Retry para erros 5xx (500, 502, 503, 504, 520, etc.) ou erros de rede
    const shouldRetry = (status >= 500 || !error.response) && config.__retryCount < MAX_RETRIES;
    
    if (shouldRetry) {
      config.__retryCount += 1;
      config.__isRetry = true;
      
      console.log(`[AXIOS GLOBAL] Retry ${config.__retryCount}/${MAX_RETRIES} para ${config.url} (erro ${status || 'rede'})`);
      
      // Backoff exponencial
      await sleep(RETRY_DELAY * config.__retryCount);
      
      return axios(config);
    }
    
    return Promise.reject(error);
  }
);

// Configurar timeout padrão
axios.defaults.timeout = 30000;

console.log('[AXIOS GLOBAL] Retry automático configurado (5 tentativas para erros 5xx)');

export default axios;
